module.exports = function() {
  return new Worker(__webpack_public_path__ + "62c054f385a611a0b15a.worker.js");
};